@let messages = messagesSg();
<!-- TODO: implement loader -->
@let showLoader =
  group.conversation.plugins.currentListPlugin.feature.selectors.isLoading.asSignal() ||
  group.messages.plugins.currentListPlugin.feature.selectors.isLoading.asSignal();
@let error =
  group.conversation.plugins.currentListPlugin.feature.selectors.error.asSignal() ||
  group.messages.plugins.currentListPlugin.feature.selectors.error.asSignal();

@if (showLoader) {
  <atn-assistant-loader />
} @else {
  <!-- Messages -->
  @for (message of messages; track message.id) {
    <atn-assistant-message
      class="atn-chat-message-list__message"
      [message]="message"
      (fileDownload)="fileDownloadClickHandler($event)"
      (retry)="retryMessageHandler($event)"
    />
  } @empty {
    @if (error) {
      Failed to load messages. {{ error }}
    } @else {
      <atn-assistant-empty-state />
    }
  }
}
